import { Box, Card, Container, Grid, Stack, Typography } from "@mui/material";

import PropTypes from "prop-types";
import React from "react";

export const NucDashboardTitle = ({ title }) => {
  return (
    <Typography variant="h1" fontWeight="bold" fontSize="1.5rem" mb={1} mt={1}>
      {title}
    </Typography>
  );
};

NucDashboardTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export const NucDashboardGrid = ({ children }) => {
  return (
    <Grid
      container
      spacing={2}
      direction="row"
      alignItems="stretch"
      sx={{ flexGrow: 1, mb: 2 }}
    >
      {children}
    </Grid>
  );
};

NucDashboardGrid.propTypes = {
  children: PropTypes.node.isRequired,
};

export const NucDashboardCardHeader = ({ title, children }) => {
  if (!title) {
    return children || null;
  }

  return (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        flexWrap="wrap"
        alignItems="center"
        gap={1}
        mb={1.5}
      >
        <Typography variant="h2" fontWeight="bold" fontSize="1.10rem">
          {title}
        </Typography>
        {children}
      </Stack>
    </Box>
  );
};

NucDashboardCardHeader.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};

export const NucDashboardCard = ({
  title,
  spanColsXs,
  spanColsSm,
  spanColsMd,
  spanColsLg,
  spanColsXl,
  children,
  headerActions,
}) => {
  return (
    <Grid
      item
      xs={spanColsXs}
      sm={spanColsSm}
      md={spanColsMd}
      lg={spanColsLg}
      xl={spanColsXl}
    >
      <Card
        variant="outlined"
        sx={{ display: "flex", flexDirection: "column", height: "100%", p: 2 }}
      >
        <NucDashboardCardHeader title={title}>
          {headerActions}
        </NucDashboardCardHeader>
        {children}
      </Card>
    </Grid>
  );
};

NucDashboardCard.propTypes = {
  title: PropTypes.string,
  spanColsXs: PropTypes.number,
  spanColsSm: PropTypes.number,
  spanColsMd: PropTypes.number,
  spanColsLg: PropTypes.number,
  spanColsXl: PropTypes.number,
  children: PropTypes.node.isRequired,
  headerActions: PropTypes.node,
};

NucDashboardCard.defaultProps = {
  spanColsXs: 12,
  spanColsSm: 6,
  spanColsMd: 6,
  spanColsLg: 6,
  spanColsXl: 6,
};

export const PageLayout = ({ children }) => {
  return <Container maxWidth="100vw">{children}</Container>;
};

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
